import React from "react";
import Footer from '../common/footer/footer';
import Header from './../common/header/header';
import "./emailverification.css";
import { API_HOST, axiosInstance, axiosRequestWithAuth } from './../../constants/server.constant';
import CommonMessage from './../common/commonMessage';
import { Redirect } from 'react-router-dom';
import { userService } from "../../services/user.service";
export class Emailverification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isAction: false,
            message: "",
            email: localStorage.getItem("email"),
            isButtonDisabled: false,
            redirectLogin: false,
            isRefreshing: true,
        };
        this.resendEmailLink = this.resendEmailLink.bind(this);
    }


    componentDidMount() {

        userService.getUserData().then((response) => {

            if(response.data.emailVerify == 1) {
                localStorage.removeItem("_email_verify");
                this.props.history.push("/login");
            } else {
                this.setState({ isRefreshing: false });
            }
        }).catch(error => {
            this.setState({
                message: "Error while getting user details, try again!"
            });
        });
        this.removeGoogleScript();

    }
    removeGoogleScript() {
        var tags = document.getElementsByTagName('script');
        for(var i = tags.length; i >= 0; i--) { //search backwards within nodelist for matching elements to remove
            if(tags[i] && tags[i].getAttribute('src') != null && tags[i].getAttribute('src').indexOf("/pagead/conversion.js") != -1)
                tags[i].parentNode.removeChild(tags[i]); //remove element by calling parentNode.removeChild()
        }
    }


    resendEmailLink = () => {
        this.setState({
            isAction: true,
            isButtonDisabled: true
        });
        setTimeout(() => {
            this.setState({
                isButtonDisabled: false
            });
        }, 10000);
        axiosInstance.get(API_HOST + "/user/resendemailverification/" + this.state.email, axiosRequestWithAuth).then((resp) => {
            console.log(resp);
            if(!resp.data.error) {
                this.setState({
                    isAction: false,
                    message: "Verification email sent successfully"
                });
            }
            else {
                this.setState({
                    redirectLogin: true
                });
            }
        }).catch(error => {
            this.setState({
                isAction: false,
                message: "Error while sending email"
            });
        });
    };

    render() {
        if(this.state.redirectLogin) {
            return <Redirect to={ {
                pathname: "/login",
                state: {
                    fromEmailPage: true
                }
            } } />;
        }
        if(this.state.isRefreshing) {
            return null;
        } else {
            return (
                <div>
                    <Header />
                    <div className="full_page_loader" style={ { display: this.state.isAction ? 'block' : 'none' } }>
                        <div className="loader_icon"></div>
                    </div>
                    <main className="static">
                        <div id="static_form_wrap">
                            <div className="wrapper">
                                <div className="email_confCtnr">
                                    <div className="email_confBox">
                                        <h2>Verify Your Email Address</h2>
                                        <div className="email_confCont">
                                            <i className="email_confIcon"></i>
                                            <span>An email has been sent to <b>{ this.state.email }</b></span>
                                            <p>Click the verification link in that email to confirm the email address.</p>
                                            <button className={ this.state.isButtonDisabled ? "btn-primary disabled" : "btn-primary" } onClick={ () => this.resendEmailLink() } disabled={ this.state.isButtonDisabled }>Resend verification email</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                    <Footer />
                    <CommonMessage message={ this.state.message } isUserSubscribed={ this.state.isUserSubscribed } handler={ () => this.setState({ message: '' }) } />
                </div>
            );
        }
    }

}